import { FilterControls } from '@/dashboards/CompetitorsMediaInvestment/components/ActionBar/FilterControls';
import { CompetitorsMediaInvestmentSearch } from '@/dashboards/CompetitorsMediaInvestment';
import { useCompetitorsMediaInvestmentTabs } from '@/dashboards/CompetitorsMediaInvestment/hooks/useCompetitorsMediaInvestmentTabs';
import { useCompetitorsMediaInvestmentUrl } from '@/dashboards/CompetitorsMediaInvestment/hooks/useCompetitorsMediaInvestmentUrl';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { PeriodOption } from '@/config/model';
import { Drawer, useMatchMedia } from '@analytical-alley/ui';
import moment from 'moment/moment';
import { useState } from 'react';
import { HiAdjustments } from 'react-icons/hi';

export const ActionBar = () => {
    const { isLg } = useMatchMedia(['lg']);
    const { tabsToRender } = useCompetitorsMediaInvestmentTabs();
    const { search, setSearch } = useCompetitorsMediaInvestmentUrl();
    const { endDate, startDate } = useDashboardGlobalContext();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const onSetSearch = (newSearch: Partial<CompetitorsMediaInvestmentSearch>) => {
        setSearch(newSearch);
    };

    const minDate = moment.utc(startDate, 'DD-MM-YYYY').toDate();
    const maxDate = moment.utc(endDate, 'DD-MM-YYYY').toDate();

    const onPeriodChange = async (period: PeriodOption) => {
        await setSearch({ ...search, period });
    };

    const controlProps = {
        search,
        minDate,
        maxDate,
        tabsToRender,
        onSetSearch,
        onPeriodChange,
    };

    if (!isLg) {
        return (
            <>
                <button
                    className="glass-tile self-center p-2 rounded-md shadow-lg hover:bg-white/30"
                    onClick={() => setIsDrawerOpen(true)}
                    aria-label="Open filters"
                >
                    <HiAdjustments className="w-5 h-5" />
                </button>

                <Drawer
                    open={isDrawerOpen}
                    onClose={() => setIsDrawerOpen(false)}
                    position="top"
                >
                    <Drawer.Header title="Filters" />
                    <Drawer.Items>
                        <FilterControls {...controlProps} vertical />
                    </Drawer.Items>
                </Drawer>
            </>
        );
    }

    return <FilterControls {...controlProps} />;
};
